import React from 'react';
import { token } from '@atlaskit/tokens';
import styled from 'styled-components';
import { FormattedDate, FormattedMessage } from 'react-intl';

import { Font, Dimensions } from 'components/visuals';
import ProductLogo from 'components/common/ProductLogo';
import {
  LicenseType,
  LICENSE_ACADEMIC,
  LICENSE_COMMUNITY,
  LICENSE_OPENSOURCE,
  LICENSE_SOCIAL_IMPACT,
  LICENSE_SOCIAL_IMPACT_GLOBAL_ACCESS,
} from 'model/hams/LicenseType';

const ExtraInfo = styled.div.attrs({
  className: 'pii',
})`
  font-size: 12px;
  color: ${token('color.text.subtle', '#44546F')};
`;

const ProductLogoWrapper = styled.div`
  img {
    max-width: 210px;
  }
`;

const ExpiryWrapper = styled.div`
  font-family: ${Font.displayFamily};
  font-size: 14px;
  color: ${token('color.text', '#172B4D')};
  font-weight: 500;
  margin-top: ${Dimensions.units(2)}px;
  margin-bottom: ${Dimensions.units(1)}px;
`;

const LicenseWrapper = styled.p`
  background-color: ${token('color.border', '#B3B9C4')};
  font-family: ${Font.displayFamily};
  font-size: ${Dimensions.units(1.5)}px;
  font-weight: 500;
  text-align: center;
  color: ${token('color.text', '#172B4D')};
  margin-top: ${Dimensions.units(2)}px;
  text-transform: uppercase;
  width: fit-content;
  padding: 0 ${Dimensions.units(0.5)}px;
  border-radius: 3px;
`;

interface Props {
  accountId: number | string;
  accountName: string;
  productKey: string;
  productName: string;
  expiryDate?: string;
  licenseType?: LicenseType;
  isNonCommercialOn: boolean;
}

const AccountSummary = ({
  accountId,
  accountName,
  productKey,
  productName,
  expiryDate,
  licenseType,
  isNonCommercialOn,
}: Props) => (
  <>
    <ProductLogoWrapper>
      <ProductLogo product={productKey} alt={productName} size="small" />
    </ProductLogoWrapper>
    {expiryDate && (
      <ExpiryWrapper>
        <FormattedMessage
          id="migrate.table.row.expiry"
          values={{
            date: (
              <FormattedDate
                value={new Date(expiryDate)}
                day="numeric"
                month="short"
                year="numeric"
              />
            ),
          }}
        />
      </ExpiryWrapper>
    )}
    <ExtraInfo> {productName} </ExtraInfo>
    <ExtraInfo> {`SEN-${accountId}`} </ExtraInfo>
    <ExtraInfo> {accountName} </ExtraInfo>
    {isNonCommercialOn && licenseType && (
      <LicenseWrapper>
        {licenseType === LICENSE_OPENSOURCE && (
          <FormattedMessage id="migrate.table.row.licenseType.opensource" />
        )}
        {licenseType === LICENSE_ACADEMIC && (
          <FormattedMessage id="migrate.table.row.licenseType.academic" />
        )}
        {licenseType === LICENSE_COMMUNITY && (
          <FormattedMessage id="migrate.table.row.licenseType.community" />
        )}
        {(licenseType === LICENSE_SOCIAL_IMPACT ||
          licenseType === LICENSE_SOCIAL_IMPACT_GLOBAL_ACCESS) && (
          <FormattedMessage id="migrate.table.row.licenseType.social" />
        )}
      </LicenseWrapper>
    )}
  </>
);

export default AccountSummary;
